import { EFeedbackType } from "../../features/contact-us/contactUsTypes";
import axiosInstance from "../api/axiosInstance";

const ALLOWED_REDIRECT_HOSTS = [
    new URL(window.config.SEASCAPE_APP_URL).hostname,
    new URL(window.config.HORIZON_APP_URL).hostname,
    new URL(window.config.SHELL_APP_URL).hostname,
    new URL(window.config.MAIN_WEBSITE_URL).hostname
];

const PROD_SHELL_APP_URL = 'https://apps.msiltd.com';
const PRE_PROD_SHELL_APP_URL = 'https://apps.pre-prod.msiltd.com';
const TEST_SHELL_APP_URL = 'https://apps.test.msiltd.com';

export const isRedirectAllowed = (url: string): boolean => {
    try {
        const parsed = new URL(url);
        return ALLOWED_REDIRECT_HOSTS.includes(parsed.hostname);
    } catch {
        return false; // Invalid URL
    }
};


export const isSafeInternalPath = (path: string) =>
    path.startsWith('/') && !path.startsWith('//'); // Prevent protocol-relative redirects


const getCookieDomainName = () => {
    return window.location.origin === PROD_SHELL_APP_URL ? ".msiltd.com" :
        window.location.origin === PRE_PROD_SHELL_APP_URL ? ".pre-prod.msiltd.com" :
            window.location.origin === TEST_SHELL_APP_URL ? ".test.msiltd.com" :
                ".msiltd.localhost";
}

const getCookieExpiration = () => {
    const now = new Date();

    const expirationMilliseconds = window.location.origin === PROD_SHELL_APP_URL ? 24 * 60 * 60 * 1000 : // 24 hours
        window.location.origin === PRE_PROD_SHELL_APP_URL ? 12 * 60 * 60 * 1000 : // 12 hours
            window.location.origin === TEST_SHELL_APP_URL ? 20 * 60 * 1000 : // 20 minutes
                20 * 60 * 1000;// 20 minutes
    now.setTime(now.getTime() + expirationMilliseconds);
    const expires = 'expires=' + now.toUTCString();
    return expires;
}

export const setCookie = (cname: string, emailAddress: string) => {
    const expires = getCookieExpiration();
    const domain = getCookieDomainName();
    document.cookie = `${cname}= ${JSON.stringify({ emailAddress })}; ${expires}; path=/; domain=${domain}`;
};

export const deleteCookie = (cname: string) => {
    const domain = getCookieDomainName();
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
}

export const redirectToMsiMainWebsite = () => {
	window.location.href = window.config.MAIN_WEBSITE_URL;
};

export async function sendErrorFeedback(error: Error) {
    const formData = new FormData();
    formData.append("feedbackType", EFeedbackType.Error);
    formData.append("subject", error.name);
    const message = error.message + 'Details:\n\n' + error.stack;
    formData.append("message", message);

    try {
        const apiUrl = window.config?.HORIZON_API_URL;
        const response = await axiosInstance.post(apiUrl + "/account/SendFeedbackV2", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        if (response.status === 200 && response.data.success) {
            alert('Your feedback has been sent successfully!');
            return;
        }
        else {
            throw new Error("Failed to send feedback. Please try again.");
        }
    }
    catch (error: Error | unknown) {
        console.log(JSON.stringify(error));
    } finally {
        redirectToMsiMainWebsite();
    }
}